import { render, staticRenderFns } from "./SearchFacets.vue?vue&type=template&id=e1e9a2a4&"
import script from "./SearchFacets.vue?vue&type=script&lang=ts&"
export * from "./SearchFacets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports